baseMergeDeep